// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3imIY","content":"styles_content__s-NqA","row":"styles_row__1M9ug","footer":"styles_footer__1EwvG","phraseLength":"styles_phraseLength__32fFN"};